(function () {
    'use strict';

    angular
        .module('app.user')
        .component('ubStepWizardProfile', {
            bindings: {
                isEditMode: '<',
                isExternal: '<',
                existingProfile: '<',
                model: '<',
                onValidationChange: '&'
            },
            controller: UserOnboardingStepWizardProfile,
            controllerAs: 'vm',
            templateUrl: 'app/user/dashboard/onboard/wizard/step-profile/user.onboard.wizard.profile.html'
        });

    /* @ngInject */
    function UserOnboardingStepWizardProfile() {

        var vm = this;             

        vm.validationChanged = validationChanged;
       
        function validationChanged(isValid) {
            vm.onValidationChange({ isValid: isValid });            
        }
       
    }
})();
